import React, { useEffect, useRef } from 'react';
import { DOMPurify } from '@/utils';

type ShadowContentRendererProps = {
    htmlContent: string;
};

export const ShadowContentRenderer = ({ htmlContent }: ShadowContentRendererProps) => {
    const hostRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (hostRef.current && htmlContent) {
            const sanitizedHtml = DOMPurify.sanitize(htmlContent);
            if (!hostRef.current.shadowRoot) {
                const shadowRoot = hostRef.current.attachShadow({ mode: 'open' });
                shadowRoot.innerHTML = sanitizedHtml;
            } else {
                hostRef.current.shadowRoot.innerHTML = sanitizedHtml;
            }
        }
    }, [htmlContent]);

    // Renders the host element for the shadow root
    return <div ref={hostRef}/>;
};

ShadowContentRenderer.displayName = 'ShadowContentRenderer';

export default ShadowContentRenderer;